//////LIBRARY//////
import { cloneDeep, filter, find, isEmpty, isEqual, isUndefined, map } from 'lodash'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
//////COMPONENTS//////
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Modals from '../../components/Modals'
import Table from '../../components/Table'
import Tooltip from '../../components/Tooltip/Tooltip'
import Button from '../../components/Ui/Buttons'
import { divisionPicsConfig } from '../../constants/AssetsPicturesConfigList'
import userPrivileges from '../../constants/PrivilegesList'
import UseCheckAll from '../../hooks/UseCheckAll'
import { uriList } from '../../routings/settings/RouteList'
import { companiesManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import { ButtonWrapper, TextModal, TableHeaderCreateButton } from '../../theme/GlobalCss'
import Theme from '../../theme/theme'
import TableTitle from '../../components/Table/components/TableTitle'
import StringFormatter from '../../helpers/StringFormatter'
import allReplace from '../../helpers/allReplace'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import CompanyActivatedIcon from '../../assets/icones/global/circle-green.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import CompanyDeactivatedIcon from '../../assets/icones/global/cross-circle-red.svg'
import Skeleton from 'react-loading-skeleton'

//////STYLED//////
const CompaniesManagerWrapper = styled.div`
	position: relative;
`
const CompaniesTypeIcon = styled.img`
	width: 16px;
	height: 16px;
	margin: 3px;
`
const CompaniesStatusIcon = styled.img`
	width: 20px;
	height: 20px;
	margin: 3px;
`
const DivisionPicsFilter = styled.div`
	display: flex;
	& > img {
		margin: 3px;
		width: 16px;
		height: 16px;
	}
`

const TextModalCustom = styled(TextModal)`
	text-align: center;
`

//////STYLED//////
// nous devons voir comment restructurer  la vue du header, le comportement des filtres à l'air se s'être amélioré, toutefois il ne sont plus positionnés correctement

const CompaniesManager = () => {
	let history = useHistory()

	const { translations, companiesManager, deleteSuccess, user, companiesFilters, isSearchfieldUpdated, currentColumn, currentDir } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			companiesManager: state.companiesManager,
			deleteSuccess: state.usersManager.deleteSuccess || false,
			companiesFilters: state.companiesManager.header || false,
			user: state.user,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsCompaniesManager = bindActionCreators(companiesManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [showModal, setShowModal] = useState(false)
	const [showModalDeactivateGroup, setShowModalDeactivateGroup] = useState(false)
	const [row, setRow] = useState({})

	const [columns, setColumns] = useState([])

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Datas
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'labelCommercial', nameDir: 'asc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Handling of divisions pics filter
	//const [cfgDivisionPics, setCfgDivisionPics] = useState([])
	const [divisionPicsFilterDisplay, setDivisionPicsFilterDisplay] = useState('')
	const [swytch, setSwytch] = useState(false)
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			withFilters: true,
			...filtersOut,
		}
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'labelCommercial', nameDir: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsCompaniesManager.getCompanies(handleFilterSend(), pg)
	}

	const handlePagingCompaniesManager = (paging) => {
		let page = cloneDeep(paging)
		const pg = {
			...page,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'labelCommercial',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			},
		}
		setPaging(pg)
		actionsCompaniesManager.getCompanies(handleFilterSend(), pg)
	}

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		if (showModal) setShowModal((prevState) => !prevState)
		if (showModalDeactivateGroup) setShowModalDeactivateGroup((prevState) => !prevState)
	}

	const stateCompanyHandler = () => {
		const mode = row.isDisable ? 'enable' : 'disable'
		actionsCompaniesManager.setStateCompany(row.id, mode)
		handleModal()
	}

	const handleDeactivateCompanyGroup = () => {
		actionsCompaniesManager.setStateCompany(row.id, 'disable')
		handleModal()
	}

	const handleModalActivate = (dataRow) => {
		setRow({ ...dataRow })
		dataRow.isGroupOrSubGroup && !dataRow.isDisable
			? setShowModalDeactivateGroup((prevState) => !prevState)
			: setShowModal((prevState) => !prevState)
	}

	const handleSeeUsers = (row) => {
		actionsCompaniesManager.setCompanyId(row)
		history.push(`${uriList.users}${uriList.usersManager}`)
	}

	const handleEditCompany = (row) => {
		history.push(`${uriList.companies}${uriList.companiesManager}${uriList.companiesEdit}/${row.id}`)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////
	// we need to declare columns like state to use it in memoisation hook
	// maybe it is not necessary to set it bye a useEffect?

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'companyManagement_companyDivision',
				dataHook: 'companiesType',
				headerName: translations['page__companiesManagement__companiesTable_division'],
				isAuthorize: true,
				//sortable: true,
				component: (props) =>
					map(props.row.companiesType, (elem) => {
						const f = find(divisionPicsConfig, { id: elem.id })
						return (
							<Tooltip
								tooltipId={`companiesType_rowid${props.row.id}_${elem.id}`}
								translationsKey={elem.translationKey.translationKey}
								position="top"
							>
								<CompaniesTypeIcon src={`${!isUndefined(f) && f.picture}`} />
							</Tooltip>
						)
					}),
			},
			// Note : "labels" trad keys doesn't contain the right value, so they are inverted
			{
				columnReferential: 'companyManagement_commercialLabel',
				dataHook: 'labelCommercial',
				headerName: translations['page__companiesManagement__companiesTable_company'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'labelCommercial',
			},
			{
				columnReferential: 'companyManagement_labelToDisplay',
				dataHook: 'labelToDisplay',
				headerName: translations['page__companiesManagement__companiesTable_labelCommercial'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'labelToDisplay',
			},
			{
				columnReferential: 'companyManagement_isDisable',
				dataHook: 'isDisable',
				headerName: translations['page__companiesManagement__companiesTable_active'],
				isAuthorize: true,
				sortable: true,
				component: (props) =>
					props.row?.rowTableSkeleton ? (
						<Skeleton width={20} height={20} style={{ lineHeight: '20px', borderRadius: '20px' }} />
					) : props.row.isDisable ? (
						<CompaniesStatusIcon src={CompanyDeactivatedIcon} />
					) : (
						<CompaniesStatusIcon src={CompanyActivatedIcon} />
					),
				useCustomSkeleton: true,
				sortableId: 'isDisabled',
			},
			{
				columnReferential: 'companyManagement_postalCode',
				dataHook: 'companyCP',
				headerName: translations['page__companiesManagement__companiesTable_postalCode'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'address.postalCode',
			},
			{
				columnReferential: 'companyManagement_city',
				dataHook: 'companyCity',
				headerName: translations['page__companiesManagement__companiesTable_city'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'address.city',
			},
			{
				columnReferential: 'companyManagement_country',
				dataHook: 'companyCountry',
				headerName: translations['page__companiesManagement__companiesTable_country'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'address.country.name',
			},
			{
				columnReferential: 'companyManagement_contact',
				dataHook: 'companyContactName',
				headerName: translations['page__companiesManagement__companiesTable_contact'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'contactName',
			},
			{
				columnReferential: 'companyManagement_companyPhone',
				dataHook: 'companyPhone',
				headerName: translations['page__companiesManagement__companiesTable_phone'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'phone',
			},
			{
				columnReferential: 'companyManagement_companyEmail',
				dataHook: 'companyEmail',
				headerName: translations['page__companiesManagement__companiesTable_email'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'email',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'companyManager',
					paperActionsList: [
						{
							name: translations['page__companiesManagement__companiesTable_modalAction_company_disable'],
							clickAction: (row) => {
								handleModalActivate(row)
							},
							isVisible: (row) => {
								return row.canDisabled
							},
						},
						{
							name: translations['page__companiesManagement__companiesTable_modalAction_company_enable'],
							clickAction: (row) => {
								handleModalActivate(row)
							},
							isVisible: (row) => {
								return row.canEnabled
							},
						},
						{
							name: translations['page__companiesManagement__companiesTable_modalAction_company_modify'],
							clickAction: (row) => {
								handleEditCompany(row)
							},
							isVisible: () =>
								!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[14])),
							translationKey: 'tooltip__admin__companiesManagement__modifyCompany',
							//iconDef: editCompanyIcon,
						},
						{
							name: translations['tooltip__admin__global__showUsers'],
							clickAction: (row) => {
								handleSeeUsers(row)
							},
							isVisible: () => !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.view[16])),
							translationKey: 'tooltip__admin__global__showUsers',
							//iconDef: seeUsersIcon,
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 20,
		labelPageTable: 'companyManagement',
	}

	// To tableTitle
	const [config, setConfig] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				defaultValue: searchValue,
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		},
	})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (!deleteSuccess) return
		actionsCompaniesManager.getCompanies(paging)
	}, [deleteSuccess])

	useEffect(() => {
		const cfg = cloneDeep(config)
		if (!isEmpty(companiesManager.items) && !isUndefined(companiesManager.items)) {
			cfg.paging = {
				totalElements: companiesManager.paging.totalElements,
				totalPages: companiesManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingCompaniesManager(paging),
			}
			// To table title
			setConfig(cfg)
		}
	}, [companiesManager.items])

	useEffect(() => {
		const filtersCp = cloneDeep(companiesFilters)

		filtersCp.withFilters = true
		setConfigTable({ ...configTable, export: { bd: filtersCp } })
		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [companiesFilters])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmit()
	}, [filters.searchField])

	/* 	// Assembling divisions pics config with rows returned
	useEffect(() => {
		if(!isEmpty(companiesManager.items)){
			let cfg = cloneDeep(cfgDivisionPics)
			forEach(companiesManager.items, elem => {

				if(elem.companiesType.length > 0){
					forEach(elem.companiesType, comp => {
						const f = find(cfg, {id:comp.id}) ? true : false
						if(!f) cfg.push(comp)
					})

				}
			})
			cfg.sort(sortPicsId)
			setCfgDivisionPics(cfg)
		}
	}, [companiesManager.items]) */

	// Reajusting divisions filter display
	useEffect(() => {
		const arr = filter(filters.filtersSelection?.divisions.filterElements, { active: true })
		if (arr.length > 0) {
			setDivisionPicsFilterDisplay(
				<DivisionPicsFilter>
					{map(arr, (elem) => {
						const f = find(divisionPicsConfig, { id: elem.id })
						if (!isUndefined(f)) {
							return <img src={`${f.picture}`} />
						}
					})}
				</DivisionPicsFilter>
			)
		} else {
			setDivisionPicsFilterDisplay('')
		}
	}, [filters.filtersSelection?.divisions.filterElements])

	useEffect(() => {
		let cfgCp = cloneDeep(config)
		cfgCp.name = translations['page__companiesManagement__companiesTable_title']
		cfgCp.actions.rest = [
			() => (
				<DropdownCheckbox
					title={divisionPicsFilterDisplay}
					data={filters.filtersSelection?.divisions.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'divisions'}
					toTranslate={true}
					label={`${translations['page__companiesManagement__filter_division']} :`}
					pics={divisionPicsConfig}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__companiesManagement__filter_statut']}
					data={filters.filtersSelection?.status.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'status'}
					toTranslate={true}
				/>
			),
		]
		// To table title
		setConfig(cfgCp)
	}, [translations, filters, divisionPicsFilterDisplay])

	/* 	useEffect(() => {
			let cfg = cloneDeep(config)
			cfg.name = translations['page__companiesManagement__companiesTable_title']
	
			setConfig(cfg)
		}, [translations]) */

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user)) return
		if (swytch) {
			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				searchField: filters.searchField,
				searchFieldUpdated: false,
			}

			actionsCompaniesManager.getCompanies(filtersCp)
			actionsColumns.setColumns([])
			setConfigTable({ ...configTable, export: { bd: { ...filtersCp } } })
			setFilters(filtersCp)
		}
	}, [swytch])

	useEffect(() => {
		return function cleanUp() {
			//actionsCompaniesManager.resetCompaniesItems()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	// We need to declare this constant to memoise the render of table
	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={companiesManager.items}
				inputConfig={configTable}
				isLoading={companiesManager.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsCompaniesManager.getCompanies}
			/>
		)
	}, [companiesManager, columns, config, translations, paging])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				title={
					row.canEnabled && row.isDisable
						? translations['modal__companiesManagement__title__companyEnabled']
						: translations['modal__companiesManagement__title__companyDisabled']
				}
				closeModalHandler={handleModal}
				showModal={showModal}
				level={row.canEnabled && row.isDisable ? '' : 'error'}
				icon={true}
			>
				<TextModal>
					{row.canEnabled && row.isDisable && (
						<Fragment>
							<p>{translations['modal__companiesManagement__body__companyEnabled']}</p>
							<p>{translations['modal__companiesManagement__body__companyEnabled_confirm']}</p>
						</Fragment>
					)}
					{row.canDisabled && !row.isDisable && (
						<Fragment>
							<p>{translations['modal__companiesManagement__body__companyDisabled']}</p>
							<p>{translations['modal__companiesManagement__body__companyDisabled_confirm']}</p>
						</Fragment>
					)}
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleModal}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>

					<Button
						actionHandler={() => stateCompanyHandler()}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={translations['modal__companiesManagement__title__companyDisabled']}
				closeModalHandler={handleModal}
				showModal={showModalDeactivateGroup}
				level={'error'}
				icon={true}
			>
				<TextModalCustom>
					{translations && !isEqual(row, {}) && (
						<p
							dangerouslySetInnerHTML={{
								__html: StringFormatter.ResponseMessageParser(
									allReplace(translations['modal__companiesManagement__body_disableCompany'], '\\\\n', '<br><br>'),
									[`<span style="color: ${Theme.colors.primary}" >${row?.labelToDisplay}</span>`]
								),
							}}
						></p>
					)}
				</TextModalCustom>
				<ButtonWrapper>
					<Button
						actionHandler={handleModal}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>

					<Button
						actionHandler={() => handleDeactivateCompanyGroup()}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<CompaniesManagerWrapper>
				<Tooltip
					tooltipId={'CompaniesManagerCreateButton'}
					translationsKey={'tooltip__admin__companiesManagement__createCompany'}
					position="bottom"
				>
					<TableHeaderCreateButton to={`${uriList.companies}${uriList.companiesManager}${uriList.companiesCreate}`} />
				</Tooltip>
				{/* <Table inputColumns={columns} inputData={companiesManager.items} inputConfig={config} isLoading={companiesManager.isLoading} /> */}
				{/*We remove <Table /> replace by this 2 elements*/}
				{!isUndefined(translations) && !isUndefined(config) && (
					<TableTitle inputConfig={config} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(config) && TableRender}
			</CompaniesManagerWrapper>
		</Fragment>
	)
}

CompaniesManager.propTypes = {}

CompaniesManager.defaultPropTypes = {}

export default CompaniesManager
